import * as React from 'react';

import './Analysing.css';

interface Props {
	delay: number;
	onComplete: () => void;
}

interface analysingState {
	image: string;
}

const NUM_THINKING_IMAGES = 9;

class Analysing extends React.Component<Props, analysingState> {
	private timeoutId?: number;

	constructor(props: Props) {
		super(props);
		const randomIndex = Math.floor(Math.random() * NUM_THINKING_IMAGES) + 1;
		this.state = {
			image: `/thinking/${randomIndex}.gif`,
		};
	}

	componentDidMount() {
		this.timeoutId = window.setTimeout(this.props.onComplete, this.props.delay * 1000);
	}

	componentWillUnmount() {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
		}
	}

	render() {
		return (
			<section className="analysing">
				<img src={this.state.image} alt="Thinking" className="thinker" />
			</section>
		);
	}
}

export default Analysing;
